import React, { useEffect, useState } from 'react';
import { Modal } from '..';
import { useWindowSize } from '../../hooks/useWindowSize';
import styles from './styles';

interface TermsOfUseModalProps {
  closeModal: () => void;
  isOpen: boolean;
  onAcceptTerms?: () => any | (() => Promise<any>);
  loading?: boolean;
}

const TermsOfUseModal: React.FC<TermsOfUseModalProps> = (props) => {
  const { closeModal, isOpen, onAcceptTerms, loading } = props;

  const [isContinueButtonDisabled, setIsContinueButtonDisabled] = useState(true);
  const [windowWidth, windowHeight] = useWindowSize();

  useEffect(() => {
    window.addEventListener('message', (ev) => {
      if (ev.data === 'bottom_scroll' && ev.origin === 'https://www.realpage.com') {
        setIsContinueButtonDisabled(false);
      }
    }, false);
  }, []);

  return (
    <Modal
      show={isOpen}
      message={(
        <div className={styles.termsModalText}>
          <div className={styles.termsModalContentContainer}>
            <div className={styles.termsModalHeaderText}>End User License Agreement</div>
            <div className={styles.termsModalInstructionText}>Please scroll down and read this agreement carefully</div>
            <div className={styles.termsIFrameContainer}>
              <iframe
                title="Smart Building EULA"
                id="frame"
                className={styles.termsContentContainer}
                style={{ height: windowHeight * (windowWidth > windowHeight ? 0.25 : 0.4) }}
                src="https://www.realpage.com/smart-building-eula/?eulaapp=9e4b099292f0457dacfc2213dfcc4a68"
              />
            </div>
          </div>
          <div className={styles.bottomButtonsContainer}>
            By clicking Accept, you understand and agree to the terms in the
            <a href="https://www.realpage.com/smart-building-eula/" target="_blank" rel="noreferrer"> RealPage Smart Building EULA </a>
              and
            <a href="https://www.realpage.com/privacy-policy/" target="_blank" rel="noreferrer"> Privacy Policy </a>
          </div>
        </div>
      )}
      buttons={[
        {
          text: 'Cancel',
          type: 'outline',
          size: 'large',
          onClick: () => {
            closeModal();
          },
        },
        {
          text: 'Continue',
          type: 'primary',
          size: 'large',
          loading,
          disabled: isContinueButtonDisabled,
          onClick: async () => {
            onAcceptTerms && await onAcceptTerms();
          },
        },
      ]}
    />
  );
};

export default TermsOfUseModal;
